/* eslint-disable import/no-anonymous-default-export */
export default {
  brands: 'eQuoteBrandsData',
  destinations: 'eQuoteDestinationsData',
  labels: 'eQuoteLabelsData',
  ships: 'eQuoteShipsData',
  shipsDestinations: 'eQuoteShipsDestinations'
}
